import React, { memo } from "react";

import Tag from "./Tag";

const CarTags = memo(({ product, small = false }) => {
  const tags = product.tags || [];

  const orderedTags = tags.sort((a, b) => {
    return b.is_featured - a.is_featured;
  });

  return (
    <>
      {
        orderedTags.map(tag => (
          <Tag
            tag={tag?.display_name}
            key={tag?.slug}
            small={small}
            color="black"
            isFeatured={tag?.is_featured}
          />
        ))
      }
    </>
  );
});

export default CarTags;
